import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ICustomerConfigurationInput } from "@/interfaces/customer-configuration.interface";
import customerConfigurationService from "@/services/customer-configuration.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type Props = UpdateByIdProps<ICustomerConfigurationInput>;

export type UseUpdateCustomerConfigurationReturn = {
  update: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useUpdateCustomerConfiguration = (): UseUpdateCustomerConfigurationReturn => {
  const fetcher = useUpdate<ICustomerConfigurationInput>({
    operation: (formData, configurationId) =>
      customerConfigurationService.update(formData, configurationId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, update } = fetcher;

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateCustomerConfiguration;
